const isProduction = process.env.VUE_APP_ENV_NAME === 'production';
const devMenuId = ['3247', '3248', '3249', '3250', '3251'];
const proMenu = ['9738', '9739', '9740', '9741', '9742'];
const titles = ['要闻', '权威发布', '代表风采', '代表之声', '学习贯彻'];
export interface NewsItemTypes {
  id: number;
  classId: number;
  title: string;
  dataType: number;
  showType: number;
  publishTime: string;
  lastDoTime: number;
  imageUrl: string[];
  isVideo: number;
  videoUrl: string;
  videoTime: string;
  doLikeNum: number;
  isDoLike: number;
  isTop: number;
  label: string;
  plNum: string;
  interactNum: string;
  isAd: number;
  pv: string;
  imageNum: number;
  category: string;
  targetUrl: string;
  sourceImage: string;
  sourceName: string;
  smallText: string;
  traceInfo: string;
  traceId: string;
  contentLength: number;
  adId: number;
  buryValue: string;
  pcUrl: string;
}
export const toPage = (data: NewsItemTypes) => {
  // const baseUrl =
  //   process.env.VUE_APP_ENV_NAME === 'production'
  //     ? 'https://wap.cqcb.com/shangyou_news'
  //     : 'https://testwap.cqcb.com/shangyou_news';
  // window.location.href = `${baseUrl}/NewsDetail?classId=${data.classId}&newsId=${data.id}`;
  window.location.href = data.targetUrl;
};
export const getChannelList = () => {
  const ids = isProduction ? proMenu : devMenuId;
  return ids.map((id) => ({
    id,
    name: titles[ids.indexOf(id)],
  }));
};
